<ion-card class="card-custom" *ngIf="okrCount > 0">
  <ion-card-header class="tooltip" has-button>
    <ion-card-title>
      OKRs
      <ion-button
        class="tooltip-button"
        color="lightblue"
        shape="round"
        mode="ios"
        [matTooltip]="getToolTipText()"
        >?</ion-button
      >
    </ion-card-title>
    <ion-item>
      <ion-label position="stacked">
        {{ "okr.areas" | translate }}
      </ion-label>
      <ion-select
        placeholder="Select"
        [(ngModel)]="attributeId"
        color="primary"
        (ionChange)="loadOkrs($event.detail.value)"
      >
        <ion-select-option
          *ngFor="let attribute of okr.visibleAttributes"
          [value]="attribute.id"
        >
          {{ attribute.type }} - {{ attribute.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <mat-accordion *ngFor="let objective of okr.objectives">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="okrHeader">
          <mat-panel-title>
            {{ objective.name }}
          </mat-panel-title>
          <!-- checar porque a cor do header muda quando abre o acordion -->
        </mat-expansion-panel-header>
        <mat-panel-description>
          <ion-list
            mode="ios"
            lines="full"
            class="full-width ion-no-margin goal-progress"
          >
            <ion-item *ngFor="let keyResult of objective.keyResults">
              <ion-label>
                <h2 style="white-space: break-spaces;">{{ keyResult.name }}</h2>
                <p>
                  <span>{{ keyResult.deadline | date: "dd/MM/yyyy" }}</span>
                </p>
                <div
                  class="progress-bar-container"
                  [ngClass]="{
                    primary: getProgressBarColor(keyResult.deadline, 'primary'),
                    success: getProgressBarColor(keyResult.deadline, 'success'),
                    danger: getProgressBarColor(keyResult.deadline, 'danger'),
                    warning: getProgressBarColor(keyResult.deadline, 'warning')
                  }"
                >
                  <div class="prohress-bar">
                    <span
                      [ngStyle]="
                        getProgressBarLength(keyResult.currentProgress)
                      "
                    ></span>
                  </div>
                  <div class="progress-bar-status">
                    {{ keyResult.currentProgress }}%
                  </div>
                </div>
              </ion-label>
              <ion-button
                color="light"
                mode="ios"
                slot="end"
                (click)="viewGoalModal(keyResult)"
              >
                <ion-icon color="primary" class="bp-view"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-list>
        </mat-panel-description>
      </mat-expansion-panel>
    </mat-accordion>
  </ion-card-content>
</ion-card>
